<template>
  <div class="loginbg flexCenter">
    <div class="login_box">
      <div class="schoolName">
        <p class="" style="margin:0;font-weight:700;font-size:20px;">{{ config.schoolName_z }} </p>
        <p style="margin:10px 0 0 0;color:#606266;">企业招聘平台</p>
      </div>
      <div v-if="!showQrcode">
        <el-form :model="EditItem">
          <el-form-item>
            <el-input placeholder="请输入账号" @keyup.enter.native="login" v-model="username">
              <i slot="prefix" class="el-input__icon el-icon-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input type="password" placeholder="请输入密码" @keyup.enter.native="login" v-model="password">
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>

            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="flexStart" style="width:100%;">
              <el-input type="text" placeholder="验证码" @keyup.enter.native="login" v-model="yzm"
                style="width:50%;"></el-input>
              <div @click="getYZM"
                style="border: 0; width: 50%; height: 50px; transform: scale(0.8,0.8); transform-origin: center;"
                v-html="yzmUrl"></div>
            </div>

          </el-form-item>
          <el-form-item>
            <div class="">
              <el-button size="medium" type="primary" style="width: 100%;font-size:18px;padding:10px 15px;"
                @click="login">登录</el-button>

              <div class="flexEnd">
                <el-link @click="removeSession" type="primary">企业注册</el-link>
              </div>
            </div>

          </el-form-item>

        </el-form>
      </div>

      <div v-else>
        <div style="width: 60%; margin: 0 auto; padding-top: 30px;">
          <img :src="qrcodeUrl ? qrcodeUrl : '../../images/qrcode.jpg'" alt style="width: 100%;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// require('../../../public/img/background.svg')
export default {
  data() {
    return {
      EditItem: {},
      username: "",
      password: "",
      session_id: "",
      yzmUrl: "",
      yzm: "",
      showQrcode: false,
      qrcodeUrl: "",
      qrcodeTimer: -1,
      config: { schoolName_z: '' },
    };
  },
  mounted() {
    if (!window.pmid) {
      window.pmid = 1;
    }
    this.getYZM();
    this.getConfig()
    this.getAppConfig()
  },
  methods: {
    getConfig() {
      this.$http.post("/api/sch_config_new", {
        ktype: 'remark', keyword: '免登录', pmid: window.pmid
      }).then(res => {
        let config = {}
        for (let k of res.data) {
          this.config[k.ktype] = k.kvalue
        }
        this.$forceUpdate()
      });
      this.$http.post("/api/sch_config_one", { pmid: window.pmid, ktype: "schoolname" }).then(res => {
        this.config.schoolName_z = res.data.kvalue
        this.$forceUpdate()
      })
    },
    getAppConfig() {
      this.$http.post("/api/sch_config_one", { pmid: window.pmid, ktype: "favico" }).then(res => {
        var link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = res.data.kvalue
        document.getElementsByTagName('head')[0].appendChild(link);
      })
    },
    removeSession() {
      this.$router.push("/enrolled");
    },
    getYZM() {
      this.$http
        .post("/api/get_login_randomcode", {
          pmid: window.pmid
        })
        .then(res => {
          this.session_id = res.data.data.session_id;
          this.yzmUrl = res.data.data.svg;
        });
    },

    login() {
      if (this.username.trim() && this.password.trim()) {
        this.$http
          .post("/api/enterprise_login", {
            loginname: this.username,
            mm: this.password,
            yzm: this.yzm.toLowerCase(),
            session_id: this.session_id,
            pmid: window.pmid,
            day: 7
          })
          .then(
            res => {
              if (res.data && res.data.auth) {
                localStorage.setItem("auth", res.data.auth);
                clearInterval(this.qrcodeTimer);

                this.$http.post("/api/enterprise_info", {}).then(res => {
                  if (res.data.check_status==2) {
                    this.$router.push("/enterInfo");
                  } else {
                    this.$router.push("/home");
                  }
                }).catch(err => {
                  this.$router.push("/home");
                });

              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                  offset: "600"
                });
              }
            },
            err => { }
          );
      } else {
        this.$message({
          message: "好像没有填完整~",
          type: "error",
          offset: "600"
        });
      }
    },



  }
};
</script>

<style scoped lang="less">
.loginbg {
  width: 100%;
  height: 100%;

  background: #f0f2f5 url('../../../public/img/background.jpeg') no-repeat 50%;

  background-size: cover;
  position: relative;



  .login_box {
    border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
    background-color: #fff;
    width: 420px;
    min-width: 260px;
    padding: 24px 36px 0 36px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.1);

    .schoolName {
      color: #3378fa;
      margin-bottom: 24px;
      font-size: 18px;
    }
  }
}
</style>
